const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

function playDeferredMedia(deferredMedia) {
  if (!deferredMedia) return;

  const play = () => {
    if (!deferredMedia.hasAttribute('data-media-loaded')) {
      deferredMedia.loadContent?.(false);
    }

    const video = deferredMedia.querySelector('video');
    if (video) {
      video.muted = true;
      video.playsInline = true;
    }

    deferredMedia.playMedia?.();
    video?.play?.().catch(() => {});
    deferredMedia.dataset.hdHoverPlaying = 'true';
  };

  if (customElements.get('deferred-media')) {
    play();
  } else {
    customElements.whenDefined('deferred-media').then(play).catch(() => {});
  }
}

function pauseDeferredMedia(deferredMedia) {
  if (!deferredMedia || deferredMedia.dataset.hdHoverPlaying !== 'true') return;

  deferredMedia.pauseMedia?.();
  const video = deferredMedia.querySelector('video');
  if (video) {
    video.pause();
  }
  delete deferredMedia.dataset.hdHoverPlaying;
}

function bindGalleryVideoPreviews(root = document) {
  root.querySelectorAll('.product-media-container--video deferred-media, .product-media-container--external_video deferred-media').forEach((deferredMedia) => {
    if (deferredMedia.dataset.hdHoverBound === 'true') return;
    deferredMedia.dataset.hdHoverBound = 'true';

    const container = deferredMedia.closest('.product-media-container--video, .product-media-container--external_video') || deferredMedia;

    if (supportsHover) {
      container.addEventListener('pointerenter', () => playDeferredMedia(deferredMedia));
      container.addEventListener('pointerleave', () => pauseDeferredMedia(deferredMedia));
    }

    container.addEventListener('focusin', () => playDeferredMedia(deferredMedia));
    container.addEventListener('focusout', () => pauseDeferredMedia(deferredMedia));
  });
}

function bindThumbnailVideoPreviews(root = document) {
  root.querySelectorAll('[data-hd-video-thumbnail][data-video-src]').forEach((thumbnail) => {
    if (thumbnail.dataset.hdHoverBound === 'true') return;
    thumbnail.dataset.hdHoverBound = 'true';

    const play = () => {
      let video = thumbnail.querySelector('.hd-video-thumbnail-preview');
      if (!video) {
        video = document.createElement('video');
        video.className = 'hd-video-thumbnail-preview';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.src = thumbnail.dataset.videoSrc;
        video.poster = thumbnail.dataset.videoPoster || '';
        thumbnail.append(video);
      }

      thumbnail.classList.add('is-video-previewing');
      video.play().catch(() => {});
    };

    const pause = () => {
      const video = thumbnail.querySelector('.hd-video-thumbnail-preview');
      thumbnail.classList.remove('is-video-previewing');
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    };

    if (supportsHover) {
      thumbnail.addEventListener('pointerenter', play);
      thumbnail.addEventListener('pointerleave', pause);
    }

    thumbnail.addEventListener('focusin', play);
    thumbnail.addEventListener('focusout', pause);
  });
}

function bindProductVideoHover() {
  bindGalleryVideoPreviews();
  bindThumbnailVideoPreviews();
}

bindProductVideoHover();
document.addEventListener('shopify:section:load', bindProductVideoHover);
